import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Input, Label } from "reactstrap";

const PathwaySwitchInputGroup = (props) => {
    return (
        <FormGroup
            switch
            data-cy={props.dataCy ? props.dataCy + "-wrapper" : undefined}
            justifyitems={props.justifyEnd ? "end" : "start"}
        >
            <Input
                type="switch"
                role="switch"
                name={props.name}
                id={props.id || props.name}
                onChange={props.onChange}
                checked={!!props.value}
                data-cy={props.dataCy ? props.dataCy + "-checkbox" : undefined}
                disabled={props.disabled}
                aria-label={props.ariaLabel}
            />
            <Label
                check
                data-cy={props.dataCy ? props.dataCy + "-label" : undefined}
                className="custom-control-label"
                htmlFor={props.id || props.name}
                style={{ float: "left" }}
            >
                {props.label}
            </Label>
        </FormGroup>
    );
};

export default PathwaySwitchInputGroup;

PathwaySwitchInputGroup.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    dataCy: PropTypes.string,
    label: PropTypes.any,
    ariaLabel: PropTypes.string,
    justifyEnd: PropTypes.bool,
    disabled: PropTypes.bool,
};
